<template lang="pug">
  #ch2intro.container-fluid
    .row.d-flex.justify-content-center.align-items-center.mt-5
      .col-12.d-flex.justify-content-center.align-items-center.mt-5
        img.chapter-logo(src="/assets/img/chapter2/la-respuesta.png")
      .col-12
        p.title
          span.d-block.top ¿Quién puede hacer
          span.d-block.bottom cuarentena en México?
      .col-12
        p.author Georgina Jiménez (@GinaRivers90)
      .col-12
        p 27 de abril de 2020
      .col-12.d-flex.justify-content-center.align-items-center
        img.intro-illustration(src="/assets/img/chapter2/Quienhacecurentena.png")
      .col-12
        p.copyright Ilustración de Rafaela López
      .col-12.col-lg-8
        p.text En días recientes, la pandemia de Coronavirus ha llegado a transformar el mundo como lo conocemos. México no ha sido la excepción y desde el 23 de marzo de este año el gobierno ha instaurado una jornada nacional de sana distancia en la que ha solicitado que todas las actividades no esenciales se detengan. Incluso desde antes se les ha pedido a los ciudadanos que permanezcan en sus casas para evitar que el virus, que ha matado casi 120 mil personas e infectado a más de dos millones, continúe propagándose.

        p.text La imposición de esta cuarentena, más voluntaria que obligatoria, ha levantado una serie de cuestionamientos y preocupaciones sobre la desigualdad y la fragilidad de la economía mexicana. Cuando el primer caso llegó a México fueron muchas las personas que pidieron una cuarentena estricta, como la que en esos momentos existía en varios países de Europa. Sin embargo, el gobierno mexicano fue claro en que la  economía en México es incapaz de soportar una cuarentena tan estricta como la que se vive ahora en Italia, en Francia o en España. En México muchas personas viven al día y la cuarentena implicaría una amenaza para  su subsistencia. Muchos de los trabajos informales que sostienen a gran parte de los mexicanos no pueden hacerse desde casa.

        p.text En Data Cívica nos queda claro que poder hacer cuarentena es también un privilegio, y nos dimos a la tarea de averiguar quién sí y quién no puede permanecer en casa.

</template>

<script>
export default {
  name: "Ch2Intro"
};
</script>

<style lang="scss">
#ch2intro {
  .chapter-logo {
    width: 220px;
  }
  .title {
    font-family: Oswald;
    font-size: 63px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.24;
    letter-spacing: normal;
    text-align: center;
    text-transform: uppercase;
    .top {
      color: #0a1d59;
    }
    .bottom {
      color: #f0bf5f;
    }
  }
  .author {
    font-family: "Inria Sans", sans-serif;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #0a1d59;
  }
  .intro-illustration {
    width: 800px;
  }
  .copyright {
    font-family: "Inria Sans", sans-serif;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: italic;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #0a1d59;
  }
  .text {
    font-family: "Inria Sans", sans-serif;
    font-size: 22px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.58;
    letter-spacing: normal;
    color: #0a1d59;
  }
}
</style>
